<template>
  <div class="price-component">
    <p class="symbol">{{ currencySymbol }}</p>
    <h2 class="price">{{ price }}</h2>
    <template v-if="decimal || period">
      <p v-if="decimal">
        .<span class="decimal">{{ decimal }}</span>
      </p>
      <p v-if="period" class="period">/{{ period }}</p>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    price: {
      type: Number,
      required: true
    },
    decimal: {
      type: Number,
      required: false,
      default: null
    },
    currencySymbol: {
      type: String,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.price-component {
  display: flex;
  align-items: baseline;
  & > * {
    margin: 0;
  }
  .symbol {
    align-self: center;
    font-size: var(--symbol-fs, 1.56em);
  }
  .price {
    font-size: var(--price-fs, 4em);
  }
  .decimal {
    font-size: var(--decimal-fs, 2.3em);
  }
  .period {
    font-size: 1em;
  }
}
</style>
